// src/features/services/ttlock/routes.tsx
import React, { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import Require from '@/shared/auth/Require';

// ⬇️ lazy feature pages
const TTLockDashboard = lazy(() =>
  import('./components/TTLockDashboard')
);
const RoomManagement = lazy(() =>
  import('./components/RoomManagement')
);

// Centralize service/script IDs for TTLock
export const TTLOCK_SERVICE_ID = 11;
export const SCRIPT_CREATE_ROOM = 0;

// Reusable small fallback
const Fallback = ({ text }: { text: string }) => (
  <div className="p-4">{text}</div>
);

// Export the routes this feature owns
export const ttlockRoutes: RouteObject[] = [
  {
    path: '/ttlock',
    element: (
      <Require ability="canViewTtlock">
        <Suspense fallback={<Fallback text="Loading TT-Lock…" />}>
          <TTLockDashboard />
        </Suspense>
      </Require>
    ),
  },
  {
    path: '/ttlock/rooms',
    element: (
      <Require ability="canManageTtlockRooms">
        <Suspense fallback={<Fallback text="Loading Rooms…" />}>
          <RoomManagement
            idService={TTLOCK_SERVICE_ID}
            idScript={SCRIPT_CREATE_ROOM}
          />
        </Suspense>
      </Require>
    ),
  },
];
